import { useMutation } from "@tanstack/react-query"
import { AxiosError } from "axios"
import z from "zod"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

export enum OperationChainType {
  PRODUCT = "PRODUCT",
  COMPONENT = "COMPONENT",
  MATERIAL = "MATERIAL",
}

export type CreateOpChainDto = {
  name: string
  type: OperationChainType
}

export const createOpChainSchema = z
  .object({
    name: z.string().min(1),
    type: z.nativeEnum(OperationChainType),
  })
  .strict()

export const useCreateOpChainMutation = () =>
  useMutation<string, AxiosError, CreateOpChainDto>({
    mutationFn: async (data) => {
      const res = await httpClient.post("/admin/op-chain", data)
      return res.data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["findAllOpChain"],
      })
      showSuccessNotification({
        title: "Success",
        message: "Operation chain created",
      })
    },
    onError: (error) => {
      showAxiosError({
        notificationTitle: "Error",
        notificationMessage:
          "Failed to create operation chain cause : " + error.message,
        showNotification: true,
        error,
      })
    },
  })
